import React from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'

import RowContent from './RowContent'
import ColumnContent from './ColumnContent'

import './text.css'

const Tags = props => props.tags.map((tag, idx) => <span key={idx}>{tag}</span>)

const Text = (props) => {
  const title = !props.title ? false : (
    <h3>{props.title}</h3>
  )

  const client = !props.client ? false : (
    <p>
      <span className='text--gray-light'>Client</span>
      {props.client}
    </p>
  )

  const tags = !props.tags ? false : (
    <p>
      <span className='text--gray-light'>Discipline</span>
      <Tags tags={props.tags} />
    </p>
  )

  let content
  if (Array.isArray(props.text)) {
    content = <ColumnContent content={props.text} />
  } else if (props.text.type === 'sections') {
    content = <RowContent content={props.text.content} />
  } else {
    content = ReactHtmlParser(props.text)
  }

  return (
    <div className='content content--text'>
      <div className='row'>
        <div className='col-xs-12 col-sm-6'>
          { title }
          { client }
          { tags }
        </div>
        <div className='col-xs-12 col-sm-6'>
          { content }
        </div>
      </div>
    </div>
  )
}

Text.propTypes = {
  title: PropTypes.string,
  client: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  text: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]).isRequired
}

export default Text



// WEBPACK FOOTER //
// ./src/components/Page/Content/Text/index.js